// extracted by mini-css-extract-plugin
export default {"container":"JoinFans_container__8euG4","headline":"JoinFans_headline__x+hql","subhead":"JoinFans_subhead__aQpps","btn":"JoinFans_btn__KSecJ","blurb":"JoinFans_blurb__btNJV"};